module.exports = __webpack_public_path__ + "static/background-gradient-radial-c0c52d8cb4eb11453249ec1229b9feb8.png";